import React, { useEffect, useState } from "react";
import './contact.css';
import ContactPic from './componenten/Contact.jpg';
import { ReactComponent as HouseImg } from './componenten/house.svg';
import { ReactComponent as PhoneImg } from './componenten/phone.svg';
import { ReactComponent as MailImg } from './componenten/mail.svg';

function Contact() {

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                const el = entry.target;

                if (entry.isIntersecting) {
                    el.classList.add('show');
                    el.style.pointerEvents = 'none';

                    const transistionDuration = 600;

                    setTimeout(() => {
                        el.style.pointerEvents = 'auto';
                    }, transistionDuration)
                }
            });
        }, []);

        const hiddenElements = document.querySelectorAll('.Icon-Text');
        hiddenElements.forEach((el) => observer.observe(el));

        return () => hiddenElements.forEach((el) => observer.unobserve(el));

    });

    return (
        <div className="Contact-Page">
            <div className="C-heading">
                <img src={ContactPic} alt="Contact picture" className="ContactPic" />
                <div className="contactoverlay">
                    <h1>Kom in contact</h1>
                </div>
            </div>
            <div className="Contact">
                <div className="contactgegevens">
                    <div className="intro">
                        <h2>Wij staan klaar voor jouw vragen</h2>
                        <p>Heb je een vraag, een idee of wil je gewoon eens praten?</p>
                        <p>Bij Mindis staat we altijd klaar om jouw vragen te beantwoorden.</p>
                    </div>
                        <div className="informatie">
                        <div className='Icon-Text'>
                            <HouseImg className='Icon' />
                            <p>Zonnelaan 62, 9742BN, Groningen</p>
                        </div>

                        <div className='Icon-Text'>
                            <PhoneImg className='Icon' />
                            <p>
                                <a href="tel:+31650641361" style={{ color: 'inherit', textDecoration: 'none' }}>
                                    06 506 41 361
                                </a>
                            </p>
                        </div>

                        <div className='Icon-Text'>
                            <MailImg className='Icon' />
                            <p>
                                <a href="mailto:info@mindis.nl" style={{ color: 'inherit', textDecoration: 'none' }}>
                                    info@mindis.nl
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Contact;